module.exports = __webpack_public_path__ + "img/attachment-black-24-dp.5d1c4358.svg";